
import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Technology', href: '/technology' },
    { name: 'Partners', href: '/partners' },
    { name: 'Contact', href: '/contact' },
    { name: 'Careers', href: '/careers' }
  ];

  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Cookie Policy', href: '/cookies' }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/8e9a1ee4738e2b22ec8494c6d9c2fbed/a045d5dcb790742516952289b55d3437.png" 
                alt="Vyoamyug" 
                className="h-12 w-auto object-contain hover:scale-105 transition-transform duration-300"
              />
            </Link>
            <p className="text-gray-400 text-base leading-relaxed mb-6 max-w-md">
              Leading the future of space exploration with cutting-edge technology and innovative missions that push the boundaries of human knowledge.
            </p>
            <div className="flex space-x-4">
              <a href="https://x.com/vyoamyug" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-900 hover:bg-blue-600 rounded-lg transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="https://www.linkedin.com/company/vyoamyug" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-900 hover:bg-blue-600 rounded-lg transition-colors duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/vyoamyug" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-900 hover:bg-blue-600 rounded-lg transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-base cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-sm cursor-pointer"
              >
                Made with Readdy
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-6 text-white">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-blue-400 mt-1 text-base"></i>
                <div>
                  <p className="text-gray-300 font-medium mb-1 text-sm">Operating Address:</p>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    Suit No #1235, 4th Floor, Panchshil Tower<br />
                    Tower A, City Vista, Near Fountain Road<br />
                    Rakshak Nagar, Kharadi, Pune<br />
                    Maharashtra 411014, India
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <i className="ri-building-line text-blue-400 mt-1 text-base"></i>
                <div>
                  <p className="text-gray-300 font-medium mb-1 text-sm">Registered Address:</p>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    8 The Green, Suite B<br />
                    Dover, Kent County<br />
                    DE 19901, USA
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-blue-400 text-base"></i>
                <a href="tel:+917620479137" className="text-gray-400 text-base hover:text-white transition-colors cursor-pointer">+91 76204 79137</a>
              </div>
              
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-blue-400 text-base"></i>
                <a href="mailto:connect@vyoamyug.com" className="text-gray-400 text-base hover:text-white transition-colors cursor-pointer">connect@vyoamyug.com</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-900 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap items-center gap-6">
              {legalLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-gray-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
            <p className="text-gray-400 text-sm text-center md:text-right">
              © 2024 Vyoamyug Inc. All rights reserved.<br />
              Incorporated in Delaware, USA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
